const handleAjaxSuccess = ({ DDC }, _event, data, settings = {}) => {
	const { dataLayer } = DDC;
	const { url } = settings;

	if (url?.indexOf?.('/apis/mycars/') > -1) {
		if (url.indexOf('statusType=SAVED') > -1) {
			dataLayer.myCars.savedVehicles = JSON.parse(
				data.responseText
			).results;
		} else if (url.indexOf('statusType=RECENTLY_VIEWED') > -1) {
			dataLayer.myCars.viewedVehicles = JSON.parse(
				data.responseText
			).results;
		} else if (url.indexOf('statusType=NOTIFICATIONS_ENABLED') > -1) {
			dataLayer.myCars.priceChangeVehicles = JSON.parse(
				data.responseText
			).results;
		}
	}
};

export default handleAjaxSuccess;
